module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheadc1-6c0cf87591243fc7823b49dbaed9255e.jpg";